import { Column, ColumnType } from "@/shared/components/table/table.model";
import { UserElementsFragment } from "@/core/graphql/graphql";
import { extractProperty } from "@/utils/extract-property";
import { TemplateRef } from "@angular/core";

export const USER_ELEMENTS_COLUMNS: (isFeaturedTemplateReference: TemplateRef<any>, contentTemplateReference2: TemplateRef<any>) =>
  Column<UserElementsFragment>[] = (isFeaturedTemplate: TemplateRef<any>, contentTemplate: TemplateRef<any>) => [
    {
      columnId: 'ID',
      caption: 'ID',
      fieldSelector: (element: UserElementsFragment) => extractProperty(element.id),
    },
    {
      columnId: 'Type',
      caption: 'Type',
      fieldSelector: (element: UserElementsFragment) => extractProperty(element.type),
    },
    {
      columnId: 'Is Featured',
      caption: 'Is Featured',
      fieldSelector: (element: UserElementsFragment) => extractProperty(element),
      type: ColumnType.Template,
      template: isFeaturedTemplate,
    },
    {
      columnId: 'Content',
      caption: 'Content',
      fieldSelector: (element: UserElementsFragment) => extractProperty(element),
      type: ColumnType.Template,
      template: contentTemplate,
    },
  ];
